
export default {
  name: 'RecipeCardComponent',
  props: {
    recipe: {
      type: Object,
      required: true,
    },
    image: {
      type: String,
      required: true,
    },
  },
  computed: {
    isRecipe() {
      try {
        return this.recipe !== undefined || false
      } catch (e) {
        return false
      }
    },
    title() {
      return this.recipe.title
    },
  },
}
